
































import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import QuestionBox from './../../question/components/QuestionBox.vue'
import MainTemplate from '@/components/MainTemplate.vue'
import { PaperItem } from '@/components'
import { getPreviewInfo } from './../models/api'
import QuestionType from './../../question/components/QuestionType.vue'

@Component({
  components: { MainTemplate, QuestionBox, PaperItem, QuestionType }
})
export default class Preview extends Vue {
  public data = []
  public loading = false
  public paper = {}
  public size = 'large'
  public get subjectId() {
    return this.$store.state.subject.value
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  // mounted
  public mounted() {
    this.getPaper()
  }
  // methods
  public clickDownload(val) {}
  public async getPaper() {
    let data = await getPreviewInfo({
      subject_id: this.subjectId
    })
    if (data.success) {
      this.data = data.msg.classification
    } else {
      this.data = []
    }
    // console.log(data)
  }
}
